import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiPOST } from '../../utilities/apiHelpers';
import { useDispatch } from 'react-redux';
import { setUser } from '../../redux/users/users';
import { toast } from 'react-toastify';
import { IoEyeOutline } from "react-icons/io5";
import { LuEyeOff } from "react-icons/lu";
import image from "../../../src/assest/image/LoginImage.png"
// Import your ForgetPassword component
import ForgetPassword from '../signup/forgetPassword';

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [Onclickphone, setOnclickphone] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // NEW: State to control the Forget Password Modal
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    phoneNo: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
      isValid = false;
    }

    if (Onclickphone) {
      if (!formData.phoneNo) {
        newErrors.phoneNo = "Phone number is required";
        isValid = false;
      } else if (!/^\d+$/.test(formData.phoneNo)) {
        newErrors.phoneNo = "Phone number must contain only numeric values";
        isValid = false;
      } else if (formData.phoneNo.length !== 10) {
        newErrors.phoneNo = "Phone number must be exactly 10 digits";
        isValid = false;
      }
    } else {
      if (!formData.email) {
        newErrors.email = "Email address is required";
        isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email address is invalid";
        isValid = false;
      }
    }

    return isValid ? {} : newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        const payload = Onclickphone
          ? { phoneNo: formData.phoneNo, password: formData.password }
          : { email: formData.email, password: formData.password };
        setLoading(true);
        const response = await apiPOST("v1/auth/login", payload);
        if (response.status === 200) {
          dispatch(setUser(response?.data?.data?.user));
          toast.success("User Login Successfully");
          localStorage.setItem("accessToken", response?.data?.data?.tokens?.access?.token);
          localStorage.setItem("refreshToken", response?.data?.data?.tokens?.refresh?.token);
          navigate("/");
        } else if (response.status === 401) {
          toast.error(response?.data?.data?.msg || response?.data?.data || "Invalid credentials");
        } else if (response.status === 404) {
          toast.error(response?.data?.data?.msg || response?.data?.data || "Email Or Phone No Not Found");
        } else if (response.status === 403 && response?.data?.data === "Your account is not verified. Please login with your email to verify your account.") {
          toast.error(response?.data?.data || "Your account is not verified. Please login with your email to verify your account.");
        }

        else {
          toast.success(response?.data?.data?.msg || response?.data?.data || "Invalid credentials");
          navigate("/VerifyOTP", { state: formData });
        }
      } catch (error) {
        toast.error(error?.data?.msg || error.message || "An unexpected error occurred");
      } finally {
        setLoading(false);
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex max-w-4xl md:mx-auto mt-20 border rounded-lg overflow-hidden shadow-lg mx-5 pb-3">
      {/* Side Content */}
      <div style={{ backgroundColor: '#F1F9FF' }} className="hidden sm:hidden flex-1 p-10 flex-col flex-wrap md:block lg:block rounded-xl m-2 justify-end">
        <div className="flex justify-center mb-6 mr-10">
          <img
            src={image}
            alt="Healthcare Products"
            className="w-80 h-auto object-contain drop-shadow-xl"
          />
        </div>
        <div className='mt-10'>
          <h2 className="text-2xl font-bold mb-4">Medicines, Home Delivered</h2>
          <p className="text-xs text-gray-400">
            Order any medicine or health product and we'll deliver it for free.
            Enjoy discounts on everything.
          </p>
        </div>
      </div>

      {/* Login Form */}
      <div className="flex-1 p-10 bg-white">
        <h4 className='text-2xl font-bold mb-2'>Log in</h4>
        <form onSubmit={handleSubmit} className="flex flex-col mt-4">
          {Onclickphone ? (
            <label className="mb-4">
              <span className="block text-gray-700 mb-2">Enter phone number</span>
              <input
                type="text"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleChange}
                placeholder="Enter phone number"
                className="w-full p-3 rounded-[8px] text-xs bg-[#F8F8F8] outline-none"
              />
              {errors.phoneNo && <span className="text-red-500 text-sm">{errors.phoneNo}</span>}
            </label>
          ) : (
            <label className="mb-4">
              <span className="block text-gray-700 text-sm mb-2">Enter Email address</span>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email address"
                className="w-full p-3 rounded-[8px] text-xs bg-[#F8F8F8] outline-none"
              />
              {errors.email && <span className="text-red-500 text-sm">{errors.email}</span>}
            </label>
          )}

          <label className="mb-4 mt-3">
            <span className="block text-gray-700 text-sm mb-2">Enter password</span>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Password"
                className="w-full p-3 rounded-[8px] text-xs bg-[#F8F8F8] outline-none"
              />
              <span
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600 cursor-pointer"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <IoEyeOutline /> : <LuEyeOff />}
              </span>
            </div>
            {errors.password && <span className="text-red-500 text-sm">{errors.password}</span>}
          </label>

          <div className='mt-6 mb-5'>
            <button
              type="submit"
              className="w-full py-2 text-white font-semibold bg-[#095D7E] rounded-full"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Log In"}
            </button>
          </div>
        </form>

        <div className="text-sm">
          {Onclickphone ? (
            <>Or login with <button onClick={() => setOnclickphone(false)} className="text-[#095D7E] font-medium">Email</button></>
          ) : (
            <>Or login with <button onClick={() => setOnclickphone(true)} className="text-[#095D7E] font-medium">Phone Number</button></>
          )}
        </div>

        <p className="mt-4 text-xs text-gray-600">
          New on mediiapp? <Link to="/signup" className="text-[#095D7E] font-medium">Sign Up</Link>
        </p>

        {/* MODIFIED: Forget Password Link as a Button to trigger Modal */}
        <p className="mt-4 text-xs text-gray-600">
          <button
            type="button"
            onClick={() => setIsForgotModalOpen(true)}
            className="text-[#095D7E] font-medium hover:underline"
          >
            Forgot Password?
          </button>
        </p>
      </div>

      {/* NEW: Rendering the Modal Component */}
      <ForgetPassword
        show={isForgotModalOpen}
        handleClose={() => setIsForgotModalOpen(false)}
      />
    </div>
  );
}

export default Login;